"use client";

import ProductCardSkeleton from "@/components/ui/skeleton/variants/productCardSkeleton";

type TrendingProductCardListSkeletonProps = {
  cardCount?: number;
};

export default function TrendingProductCardListSkeleton({
  cardCount = 4,
}: TrendingProductCardListSkeletonProps) {
  return (
    <div className="md:mb-12">
      <div className="h-8 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />

      <div className="dynamic-grid flex-wrap gap-4 py-4">
        {Array.from({ length: cardCount }).map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>

      <div className="flex justify-center mt-6 md:mt-5">
        <div className="h-10 bg-gray-200 rounded w-32 animate-pulse" />
      </div>
    </div>
  );
}
